import * as windowMetadata from "@walletconnect/window-metadata";
export function getClientMeta() {
  return windowMetadata.getWindowMetadata();
}